var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadio2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 23,
    viewBox: "0 0 39 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-5 -12.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    transform: "translate(5 12.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    transform: "translate(19 16.5)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 2,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 1,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    transform: "translate(5 25.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    transform: "translate(19 29.5)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 2,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 1,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    transform: "translate(8 15.5)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio2);
export default __webpack_public_path__ + "static/media/radio2.b92ee8a433b8316f17a60a50bb524433.svg";
export { ForwardRef as ReactComponent };